import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FleetActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import List from '../../../components/Fleet/Trailers/List';

class Units extends Component {
  componentWillMount() {
    this.props.dispatch(FleetActions.getTrailers());
  }
  newTrailer = () => {
    browserHistory.push('/fleet/trailer');
  }
  render() {
    const { auth, fleet } = this.props;
    const profile = auth.getProfile();
    const isAdmin = _.includes(profile.roles, 'admin');
    let content;
  
    if (!fleet || !fleet.trailers || fleet.trailers.fetching) {
      content = <Loader />;
    } else {
      if (fleet.trailers.list.length === 0) {
        content = <h2>No Trailers Devices</h2>;
      } else {
        content = <List dataProvider={fleet.trailers.list} isAdmin={isAdmin} multiSelectable={false} />;
      }
    }

    const subnavItems = [{ key: 1, label: 'New', onClick: this.newTrailer }]
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Trailers" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, fleet } = state;
  return {
    auth: auth.auth,
    fleet,
  }
}

export default connect(mapStateToProps)(Units);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Trailers/index.js